module.exports = __webpack_public_path__ + "front/img/header-kv.aeae1382.png";